import styled from 'styled-components/macro';
import { Checkbox as AntdCheckbox } from 'antd';
export const StyledCheckboxGroup = styled(AntdCheckbox.Group)`
  .ant-space.ant-space-vertical .ant-checkbox-wrapper {
    align-items: flex-start;
  }
`;
